import { useTransportQuery } from "@/transport"

import type { QueryDashboardBatchRequest } from "@/types_api/backend/transport/query_dashboard_batch_request"

interface QueryOptions {
  enabled?: boolean
  staleTime?: number
  gcTime?: number
}

export function useDashboardBatchTransportQuery({
  request,
  options,
}: {
  request: QueryDashboardBatchRequest
  options?: QueryOptions
}) {
  return useTransportQuery({
    operation: "queryDashboardBatch",
    request,
    options,
  })
}
